import React, { createContext, useContext, useState, ReactNode } from 'react';

interface HierarchyMenuContextType {
    openMenuId: string | null;
    setOpenMenuId: (id: string | null) => void;
}

const HierarchyMenuContext = createContext<HierarchyMenuContextType | undefined>(undefined);

export function HierarchyMenuProvider({ children }: { children: ReactNode }) {
    const [openMenuId, setOpenMenuId] = useState<string | null>(null);

    return (
        <HierarchyMenuContext.Provider value={{ openMenuId, setOpenMenuId }}>{children}</HierarchyMenuContext.Provider>
    );
}

export function useHierarchyMenu() {
    const context = useContext(HierarchyMenuContext);
    if (!context) {
        throw new Error('useHierarchyMenu must be used within HierarchyMenuProvider');
    }
    return context;
}
